export function getMainDomain() {
  const hostname = window.location.hostname;

  // 如果是IP地址，直接返回
  if (/^\d{1,3}\.\d{1,3}\.\d{1,3}\.\d{1,3}$/.test(hostname)) {
    return hostname;
  }

  // 处理localhost情况
  if (hostname === "localhost") {
    return hostname;
  }

  // 分割域名部分
  const parts = hostname.split(".");

  // 处理类似.co.uk这样的国家代码顶级域名
  if (parts.length > 2) {
    // 如果是类似xxx.com.cn这样的域名，取最后两部分
    if (parts[parts.length - 2].length <= 3) {
      return parts.slice(-3).join(".");
    }
    return parts.slice(-2).join(".");
  }

  return hostname;
}
